import ContextManager from '@/util/contextManager'
import constants from '@/util/constants'

const ContextManagerPlugin = {
  install (Vue) {
    const contextManager = new ContextManager(constants.definicoesContexto)

    Vue.prototype.$contextManager = contextManager
  }
}

export default ContextManagerPlugin
